import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "../../../base/button/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "../../../base/tooltip/tooltip";
/**
 * Shared icon-button for flow-toolbar primitives. Uses `secondary` variant
 * when active to visually indicate the selected tool.
 */ export function ToolbarButton({ onClick, disabled, tooltip, active, children }) {
    return /*#__PURE__*/ _jsxs(Tooltip, {
        children: [
            /*#__PURE__*/ _jsx(TooltipTrigger, {
                asChild: true,
                children: /*#__PURE__*/ _jsx(Button, {
                    variant: active ? "secondary" : "ghost",
                    size: "icon",
                    onClick: onClick,
                    disabled: disabled,
                    children: children
                })
            }),
            /*#__PURE__*/ _jsx(TooltipContent, {
                side: "top",
                children: tooltip
            })
        ]
    });
}

//# sourceMappingURL=ToolbarButton.js.map